export const DOCTOR_REQUEST_TYPE = {
  DOCTOR_DEFAULT: 'default',
  DOCTOR_LINK: 'doctor_link',
  DOCTOR_SELECT_SCHEDULE: 'doctor_select_schedule',
};
